
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAlertListDetails as ObcAlertListDetailsElement} from '@oicl/openbridge-webcomponents/dist/components/alert-list-details/alert-list-details.js';
 import {ObcAckClickEvent, ObcRowClickEvent} from '@oicl/openbridge-webcomponents/dist/components/alert-list-details/alert-list-details.js';
 export type {ObcAckClickEvent, ObcRowClickEvent} from '@oicl/openbridge-webcomponents/dist/components/alert-list-details/alert-list-details.js';
 

 
 export const ObcAlertListDetails = createComponent({
   react: React,
   tagName: 'obc-alert-list-details',
   elementClass: ObcAlertListDetailsElement,
   events: {
     
     onAckClick: 'ack-click' as EventName<ObcAckClickEvent>,
     onRowClick: 'row-click' as EventName<ObcRowClickEvent>,
   }
  });
 
 